var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgImpulsePin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 130,
    height: 145,
    viewBox: "0 0 130 145",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1707_319)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31 4C18.2975 4 8 14.2975 8 27V95C8 107.703 18.2975 118 31 118H52.5L65 133L77 118H99C111.703 118 122 107.703 122 95V27C122 14.2975 111.703 4 99 4H31Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53 55C54.6569 55 56 53.6569 56 52C56 50.3431 54.6569 49 53 49C51.3431 49 50 50.3431 50 52C50 53.6569 51.3431 55 53 55Z",
    fill: "#27B0D4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65 55C66.6569 55 68 53.6569 68 52C68 50.3431 66.6569 49 65 49C63.3431 49 62 50.3431 62 52C62 53.6569 63.3431 55 65 55Z",
    fill: "#27B0D4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80 52C80 53.6569 78.6569 55 77 55C75.3431 55 74 53.6569 74 52C74 50.3431 75.3431 49 77 49C78.6569 49 80 50.3431 80 52Z",
    fill: "#27B0D4"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44 28C39.0294 28 35 32.0294 35 37V82C35 83.0907 35.5919 84.0954 36.546 84.6241C37.5 85.1527 38.6657 85.1219 39.5905 84.5437L53.644 75.7563H86C90.9706 75.7563 95 71.7269 95 66.7563V37C95 32.0294 90.9706 28 86 28H44ZM41 37C41 35.3431 42.3431 34 44 34H86C87.6569 34 89 35.3431 89 37V66.7563C89 68.4132 87.6569 69.7563 86 69.7563H52.7833C52.2209 69.7563 51.6697 69.9144 51.1928 70.2126L41 76.586V37Z",
    fill: "#27B0D4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1707_319",
    x: 0,
    y: 0,
    width: 130,
    height: 145,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1707_319"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1707_319",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImpulsePin);
export default __webpack_public_path__ + "static/media/impulse-pin.b4b2841f2c6e514bff400ba0e431337a.svg";
export { ForwardRef as ReactComponent };